function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.7313 11.8646C4.7313 13.0968 3.73233 14.0958 2.50005 14.0958C1.26776 14.0958 0.268799 13.0968 0.268799 11.8646C0.268799 10.6323 1.26776 9.6333 2.50005 9.6333C3.73233 9.6333 4.7313 10.6323 4.7313 11.8646Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.7313 2.93981C4.7313 4.17209 3.73233 5.17106 2.50005 5.17106C1.26776 5.17106 0.268799 4.17209 0.268799 2.93981C0.268799 1.70752 1.26776 0.708557 2.50005 0.708557C3.73233 0.708557 4.7313 1.70752 4.7313 2.93981Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.7313 20.7899C4.7313 22.0222 3.73233 23.0212 2.50005 23.0212C1.26776 23.0212 0.268799 22.0222 0.268799 20.7899C0.268799 19.5576 1.26776 18.5587 2.50005 18.5587C3.73233 18.5587 4.7313 19.5577 4.7313 20.7899Z",
  fill: "white"
});

const SvgMoreVertical = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 5,
    height: 24,
    viewBox: "0 0 5 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgMoreVertical, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/more_vertical.eb388394.svg";
export { ForwardRef as ReactComponent };